<template>
  <v-card>
    <v-card-title>
      <h3>Proof of Educational Loan Repayment</h3>
    </v-card-title>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 pr-4
          >Please complete and submit this form and all required supporting
          documentation no later than August 15.</v-flex
        >
      </v-layout>
      <br />
      <v-flex xs12 style="text-align: left"
        >Healthcare Provider Information</v-flex
      >
      <v-divider></v-divider>
      <v-layout row wrap>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Name"
            :value="`${pop.HealthCareProvider.LastName}, ${pop.HealthCareProvider.FirstName}, ${pop.HealthCareProvider.MiddleName}`"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Email"
            :value="pop.HealthCareProvider.WorkEmail"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Address"
            :value="pop.HealthCareProvider.Address.RAddressLine1"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="City, State, Zip"
            :value="`${pop.HealthCareProvider.Address.RCity}, ${pop.HealthCareProvider.Address.RState}, ${pop.HealthCareProvider.Address.RZip}`"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Home Phone"
            :value="pop.HealthCareProvider.CellPhone"
            mask="(###)###-####"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Work Phone"
            :value="pop.HealthCareProvider.WorkPhone"
            mask="(###)###-####"
            readonly
          ></v-text-field>
        </v-flex>
      </v-layout>
      <br />
      <v-flex xs12 style="text-align: left"
        >Payment to Educational Loans</v-flex
      >
      <v-divider></v-divider>
      <v-layout row wrap>
        <v-flex xs12 pr-4 style="text-align: left; padding-left: 8px">
          A. Please complete the following information for each loan receiving a
          payment of funds from the Wyoming State Loan Repayment Program.
          <br />B. Payment cannot be made to loans not included in your
          application to the Wyoming State Loan Repayment Program. <br />C.
          Attach proof of payment(s) to loan(s) including statements showing
          payment and/or online account access printouts from the lender. Do not
          attach cancelled checks and/or online account printouts showing EFT
          payments unless they specifically show a matching lender name,
          account/loan number and amount paid.
          <br />
          D. Total payment to all loans must equal {{ totalFunds }}.
        </v-flex>
      </v-layout>
      <v-layout row wrap v-for="l in pop.LenderLoanInfo" :key="l.ID">
        <v-flex xs12 sm4>
          <v-text-field
            label="Lender"
            :value="l.LendingInstitutionName"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4>
          <v-text-field
            label="Account Number"
            :value="l.LoanAccountNumber"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4>
          <v-text-field
            label="Amount Paid"
            v-model="l.ProofOfPayments[0].AmountPaid"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-flex xs12 v-for="s in submitted" :key="s.ID">
        <v-layout
          row
          wrap
          v-if="
            currentPopStatus.User.RoleID != 1 &&
            currentPopStatus.Status.Description != 'New'
          "
        >
          <v-flex xs12 md6 pr-4>
            <v-text-field
              label="HealthCare Provider"
              :value="`${s.User.FirstName} ${s.User.LastName}`"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6 pr-4>
            <v-text-field
              label="Date"
              :value="s.ChangedOn | formattedDate"
              readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 v-for="s in adminApproval" :key="s.ID">
        <v-layout
          row
          wrap
          v-if="
            service.Application.User.RoleID != 1 &&
            service.CurrentStatus.Status.Description != 'New'
          "
        >
          <v-flex xs12 md6 pr-4>
            <v-text-field
              label="Admin"
              :value="`${s.User.FirstName} ${s.User.LastName}`"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6 pr-4>
            <v-text-field
              label="Date"
              :value="s.ChangedOn | formattedDate"
              readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-layout row wrap>
        <v-flex xs12 v-for="d in popDocs" :key="d.ID">
          <doc-item :doc="d.Document"></doc-item>
        </v-flex>
      </v-layout>
      <doc-upload
        :app_id="pop.Id"
        type="ProofOfPayment"
        v-on:upload="documentAdded"
      ></doc-upload>
    </v-card-text>
    <v-card-actions>
      <v-btn v-if="applicantCanSubmitPOP" @click="submitPOP" color="primary"
        >submit proof of payment</v-btn
      >
      <v-btn v-if="applicantCanReSubmitPOP" @click="submitPOP" color="primary"
        >Resubmit proof of payment</v-btn
      >
      <v-btn v-if="ApprovedPOP" @click="approvePOP" color="primary"
        >Approve Proof Of Payment</v-btn
      >
      <v-btn color="secondary" @click="close">close</v-btn>

      <v-dialog v-model="Submit" width="500">
        <v-card>
          <v-card-text>You have submitted the Proof of Payment.</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="Submit = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="Approved" width="500">
        <v-card>
          <v-card-text>You have approved the Proof Of Payment.</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="Approved = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment'
import { authComputed } from '@state/helpers'
import DocumentItemVue from '../AdditionalDocuments/DocumentItem.vue'
import DocumentUploadVue from '../AdditionalDocuments/DocumentUpload.vue'
export default {
  props: {
    pop: Object,
  },
  data() {
    return {
      Submit: false,
      Approved: false,
    }
  },
  computed: {
    ...authComputed,
    year() {
      return moment(this.pop.DateReward).add(1, 'year').format('YYYY')
    },
    currentStatus() {
      let list = JSON.parse(JSON.stringify(this.pop.POPStatus))
      list = list.sort((a, b) => {
        return new Date(b.ChangedOn) - new Date(a.ChangedOn)
      })
      return list[0].Status.Description || ''
    },
    currentPopStatus() {
      let list = JSON.parse(JSON.stringify(this.pop.POPStatus))
      list = list.sort((a, b) => {
        return new Date(b.ChangedOn) - new Date(a.ChangedOn)
      })
      if (list.length > 0) {
        return list[0]
      } else {
        return []
      }
    },
    submitted() {
      let list = JSON.parse(JSON.stringify(this.pop.POPStatus))
      list = list.filter((l) => {
        return l.Status.Description == 'New'
      })
      list.sort((a, b) => {
        return new Date(b.ChangedOn) - new Date(a.ChangedOn)
      })
      if (list.length > 0) {
        return [list[0]]
      } else {
        return []
      }
    },
    adminApproval() {
      let statuses = JSON.parse(JSON.stringify(this.pop.POPStatus))
      statuses = statuses.filter((i) => {
        return i.Status.Description == 'Approved'
      })
      statuses.sort((a, b) => {
        return new Date(b.ChangedOn) - new Date(a.ChangedOn)
      })
      if (statuses.length > 0) {
        return [statuses[0]]
      } else {
        return []
      }
    },
    totalFunds() {
      let sum = this.pop.FederalFunds + this.pop.Generalfunds
      return sum.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
    },
    popDocs() {
      return this.pop.ApplicationDocuments.filter((i) => {
        return i.Type == 'ProofOfPayment'
      })
    },

    applicantCanSubmitPOP() {
      //debugger
      return this.currentStatus == 'New' && this.isApplicant
    },
    applicantCanReSubmitPOP() {
      //debugger
      return this.isApplicant && this.currentStatus == 'Submitted'
    },
    ApprovedPOP() {
      return this.isAdmin && this.currentStatus == 'Submitted'
    },
  },
  methods: {
    close() {
      this.$emit('closePop')
    },
    canVerify(application) {
      //debugger
      let start
      let status = this.service.POPStatus[0].User.RoleID
      return status != 1
    },
    approvePOP() {
      axios
        .post(`ProofOfPayment\Approve`, this.pop)
        .then((response) => {
          this.$emit('changedPOP')
          this.close()
        })
        .catch((error) => {
          console.log(error)
        })
      this.Approved = true
    },
    documentAdded(item) {
      this.$emit('documentAdded', item)
    },
    updatePOP() {
      this.$emit('changedPOP')
    },
    submitPOP() {
      axios
        .post(`ProofOfPayment\Submit`, this.pop)
        .then((response) => {
          this.$emit('changedPOP')
          this.close()
        })
        .catch((error) => {
          console.log(error)
        })
      this.Submit = true
    },
  },
  components: {
    'doc-item': DocumentItemVue,
    'doc-upload': DocumentUploadVue,
  },
}
</script>

<style>
.dropbox {
  outline: 2px dashed rgb(190, 190, 190); /* the dash box */
  outline-offset: -10px;
  background: #fafafa;
  color: dimgray;
  padding: 10px 10px;
  position: relative;
  cursor: pointer;
  /* width: 20%; */
  height: 100px;
  /* margin-left: auto;
  margin-right: auto;  */
  margin-top: 10px;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 100px;
  position: absolute;
  cursor: pointer;
  left: 0;
}
</style>
